/* src/app/components/tabBar/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { AppBar, Tabs, Tab } from '@material-ui/core';

const TabBar = ({ onChange, value, labels, fullWidth }) => (
  <AppBar position="sticky" color="default">
    <Tabs
      value={value}
      onChange={onChange}
      indicatorColor="primary"
      textColor="primary"
      centered
      fullWidth={fullWidth}
      scrollable
    >
      {labels.map((label, i) => (
        <Tab label={label} key={i} />
      ))}
    </Tabs>
  </AppBar>
);

TabBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  fullWidth: PropTypes.bool,
};

TabBar.defaultProps = {
  fullWidth: false,
};

export default TabBar;



// WEBPACK FOOTER //
// ./src/app/components/TabBar/index.js